import React from 'react';
import { AlertTriangle, Construction, Clock, Info } from 'lucide-react';

interface ConstructionBannerProps {
  className?: string;
}

const ConstructionBanner: React.FC<ConstructionBannerProps> = ({ className = '' }) => {
  return (
    <div className={`bg-gradient-to-r from-amber-50 via-yellow-50 to-amber-50 border-b border-amber-200 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-start sm:items-center space-x-3">
          <div className="flex-shrink-0">
            <div className="flex items-center justify-center h-10 w-10 rounded-full bg-amber-100 border border-amber-300">
              <Construction className="h-5 w-5 text-amber-600" />
            </div>
          </div>
          
          <div className="flex-1">
            <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
              <h3 className="text-sm font-semibold text-amber-900 flex items-center">
                <AlertTriangle className="h-4 w-4 mr-1.5" />
                Site Under Construction
              </h3>
              <span className="hidden sm:inline text-amber-400">•</span>
              <div className="flex items-center text-xs text-amber-700 mt-1 sm:mt-0">
                <Clock className="h-3 w-3 mr-1" />
                API Access Pending Approval
              </div>
            </div>
            
            <p className="mt-2 text-sm text-amber-800">
              We're currently awaiting API access approval from our ticketing partners. 
              Most features are temporarily limited while we finalize integrations. 
              You can still explore the interface and set up your profile.
            </p>
            
            <div className="mt-3 flex flex-wrap gap-2">
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200">
                <Info className="h-3 w-3 mr-1" />
                Limited Functionality
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200">
                Profile Setup Available
              </span>
              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 border border-green-200">
                Demo Mode Active
              </span>
            </div>
          </div>
          
          <button 
            onClick={() => {
              const banner = document.getElementById('construction-banner');
              if (banner) {
                banner.style.display = 'none';
                sessionStorage.setItem('construction-banner-hidden', 'true');
              }
            }}
            className="flex-shrink-0 ml-4 text-amber-600 hover:text-amber-800 transition-colors"
            aria-label="Dismiss banner"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConstructionBanner;